import React from 'react';
import classNames from 'classnames';

import { ExternalLink } from '../../components';

import css from './LanguageSwitch.module.css';

// MassageDerniereMinute: bilingual FR/EN setup.
// Each deployment (massagederniereminute.com and samedaymassage.com) is its own copy of this
// app, pointed at the same Sharetribe marketplace. REACT_APP_FORCE_LOCALE tells this
// deployment which language it serves, and REACT_APP_ALTERNATE_LOCALE_URL tells it where the
// sister site (in the other language) lives. Both are set per-deployment in Render, see
// .env-template.
const isEnglish = process.env.REACT_APP_FORCE_LOCALE === 'en';
const alternateLocaleUrl = process.env.REACT_APP_ALTERNATE_LOCALE_URL;

/**
 * FR/EN language switch. Links to the sister marketplace domain (the other language),
 * keeping the visitor on the same page.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.currentPath current pathname (+ search), so the switch lands on the same page
 * @param {string?} props.className
 * @param {string?} props.rootClassName
 * @returns {JSX.Element|null} null if REACT_APP_ALTERNATE_LOCALE_URL isn't configured on this deployment
 */
const LanguageSwitch = props => {
  const { className, rootClassName, currentPath = '' } = props;

  if (!alternateLocaleUrl) {
    return null;
  }

  const classes = classNames(rootClassName || css.root, className);
  const targetHref = `${alternateLocaleUrl}${currentPath}`;
  const targetLabel = isEnglish ? 'FR' : 'EN';

  return (
    <ExternalLink href={targetHref} target="_self" className={classes}>
      {targetLabel}
    </ExternalLink>
  );
};

export default LanguageSwitch;
